import { useMutation } from "@tanstack/react-query";
import { monthlyTrainingPlanSummaryApi } from "../../../../../services/human-organization/monthly-training-plan-summary.service";

export const useCreateMTPS = () => {
  return useMutation({
    mutationFn: (body: any) => {
      const request = monthlyTrainingPlanSummaryApi.toRequest(body);
      return monthlyTrainingPlanSummaryApi.create(request);
    },
  });
};
